<template>
	<div>
		<Header />
		<!-- <ClientHeader /> -->
		<div>
			<div class="banner">
				<div>
					<p>Ai产品+专业服务</p>
					<p>为客户精准赋能，驱动业务增长，提升竞争力</p>
				</div>
			</div>
			<div class="mainContent">
				<div>
					<p class="moduleTitle">Ai产品，助力企业加速增值</p>
					<!-- <router-link tag="a" to="/professionalVSoftIndex">软性指标页面</router-link> -->
					<ul class="AIProduct">
						<li>
							<div class="system">
								<img src="../../assets/img/home/realization.png" alt="" />
								<div>
									<p>数据变现系统</p>
									<p>释放数据潜力，实现价值最大化</p>
									<button class="buttonFill"
										@click="fillProduct(domain.partyDomain+'#/home',false)">立即使用</button>
								</div>
							</div>
							<div class="productItem">
								<div @click="fillProduct(domain.partyDomain+'dataProfessional/#/dataValuationInfo?type=13',false)">
									<p>数据估值</p>
									<p>收益贡献法+机器深度学习估值法</p>
								</div>
								<!-- <div @click="fillProduct(domain.partyDomain+'dataValuation/#/dataValuationInfoFast?type=15',false)">
									<p>数据估值快速版</p>
									<p>机器深度学习估值法+多维度指标体系</p>
								</div> -->
								<div @click="fillProduct(domain.partyDomain+'dataValuation/#/basicInformationEvaluation?type=14',false)">
									<p>数据质量评价</p>
									<p>对数据资源各纬度综合平价</p>
								</div>
								<div @click="fillProduct(domain.partyDomain+'#/dataDiscoveryIntroduction',false)">
									<p>数据变现</p>
									<p>助力企业实现数据价值最大化</p>
								</div>
							</div>
						</li>
						<li>
							<div class="system">
								<img src="../../assets/img/home/investment.png" alt="" />
								<div>
									<p>数智投资系统</p>
									<p>智慧投资，创造数字财富未来</p>
									<button class="buttonFill" @click="fillProduct('/valuation',true)">立即使用</button>
								</div>
							</div>
							<div class="productItem">
								<div @click="fillProduct('/valuation',true)">
									<p>成长期企业专业估值</p>
									<p>Ai估值模型+指标体系+算法</p>
								</div>
								<div @click="fillProduct('/valuation',true)">
									<p>初创期企业估值</p>
									<p>最近融资价格法+估值图谱</p>
								</div>
								<div @click="fillProduct('/valuation',true)">
									<p>在线尽调</p>
									<p>尽调工具省时省力，揭示风险，优化价值</p>
								</div>
								<div @click="fillProduct('/valuation',true)">
									<p>财务预警与分析</p>
									<p>提前预警，防患于未然</p>
								</div>
							</div>
						</li>
					</ul>
				</div>

				<div>
					<p class="moduleTitle">专业服务，提升企业竞争力</p>
					<div class="services">
						<div class="category">
							<p :class="{'active':serviceIdx==i}" v-for="(item,i) in services" @click="selectServiceCategory(i)">
								{{item.title}}
							</p>
						</div>
						<div>
							<p>{{services[serviceIdx].title}}</p>
							<ul>
								<li v-for="(serverItem,s) in services[serviceIdx].specificService">
									<span>{{serverItem.title}}</span>
									<span>
										<i>{{serverItem.describe}}</i>
										<i class="seeDetails" @click="serverDetails(services[serviceIdx].url,s+1)">查看详情</i>
									</span>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div>
					<p class="moduleTitle">新闻资讯</p>
					<div v-if="newList.length==0" class="nothing" style="height: 200px;">
						<div v-if="nothing">
							<img src="../../assets/img/img_nothing.png" alt="暂无信息" style="margin-top: 0;height: 120px;" />
							<p>暂无信息</p>
						</div>
					</div>
					<div v-else>
						<ul class="news">
							<li v-for="(item,index) in newList" @click="newsDetails(item.id)">
								<img :src="item.img" />
								<div>
									<p>{{item.title}}</p>
									<p>{{item.brief}}</p>
								</div>
							</li>
						</ul>

						<router-link class="moreNews buttonFill" tag="a" to="/newsInformation">查看更多</router-link>

					</div>

				</div>



			</div>



		</div>
		<ContactUs />
		<Footer />
	</div>
</template>

<script>
	import Header from '@/common/header'
	import ClientHeader from '@/common/client'
	import Footer from '@/common/footer.vue'
	import ContactUs from '@/common/contactUs.vue'
	import publicMethod from '@/views/publicMethod'

	import qs from 'qs'
	import axios from 'axios';

	export default {
		mixins: [publicMethod],
		components: {
			Header,
			Footer,
			ContactUs,
			ClientHeader

		},
		data() {
			return {
				serviceIdx: 0,
				services: [{
					title: '数据类服务',
					url:'dataService',
					specificService: [{
						title: '数据资产交易撮合',
						describe: '智驭数据资产，精准撮合交易，共创价值未来！'
					}, {
						title: '数据资产交易所挂牌',
						describe: '数据资产挂牌启航，智驭未来价值蓝海！'
					}, {
						title: '数据产品质量评估',
						describe: '精准评估数据质量，筑基可信信息未来！'
					}, {
						title: '数据资源入表',
						describe: '让数据资产一目了然，驱动决策新高度！'
					}]
				}, {
					title: '股权类服务',
					url:'equity',
					specificService: [{
						title: '区域性股权市场挂牌',
						describe: '携手区域股权市场，点亮企业挂牌资本路！'
					}, {
						title: '股权激励筹划',
						describe: '定制激励方案，激发团队潜能，共创辉煌未来！'
					}, {
						title: '合规股改方案咨询',
						describe: '专业股改方案咨询，高效合规，引领企业前行！'
					}, {
						title: '股权投融资',
						describe: '精准对接股权投融资，携手共创财富增长新纪元！'
					}]
				}, {
					title: '商情类服务',
					url:'businessServices',
					specificService: [{
						title: '商业计划书撰写',
						describe: '匠心打造，精准呈现价值，铺就融资快车道！'
					}, {
						title: '可行性报告撰写',
						describe: '深度剖析项目潜力，为投资决策提供坚实支撑！'
					}, {
						title: '尽职调查',
						describe: '全面尽调，洞悉风险，为您的投资安全精准导航！'
					}, {
						title: '项目申报',
						describe: '一站式申报服务，把握政策机遇，助力企业飞速发展！'
					}]
				}],
				newList: [],
				nothing: true,

			}
		},
		mounted() {
			var this_ = this

			// setTimeout(function() {
			// 	this_.findDataInformation(1)
			// }, 8000)

			this.findDataInformation(1)
			


		},
		methods: {
			selectServiceCategory(i) {
				this.serviceIdx = i
			},
			findDataInformation(pageNum) {
				this.nothing = false
				this.$post(this.domain.dataRealization + 'dataInformation/getDataInformationList', qs.stringify({
						pageNum: pageNum,
						pageSize: 4,
						status: 1,
					}))
					.then((res) => {
						this.newList = res.data.content.records
						if (res.data.content.records.length == 0) this.nothing = true
					});
			},
			newsDetails(id) {
				this.$router.push({
					name: 'informationDetails',
					query: {
						id: id
					}
				})
			},



		}
	}
</script>

<style scoped lang="less">
	.banner {
		width: 100%;
		height: 450px;
		// background: url(../../assets/img/home/banner.png) top right no-repeat;
		background: url(../../assets/img/home/banner.png) center center no-repeat;
	}

	.banner p {
		width: 100%;
		font-weight: bold;
		color: #282828;
	}

	.banner p:nth-of-type(1) {
		font-size: 40px;
		margin-bottom: 20px;
	}

	.banner p:nth-of-type(2) {
		font-size: 24px;
	}

	.mainContent {
		width: 1200px;
		margin: 0 auto 80px;
	}

	.moduleTitle {
		font-size: 28px;
		font-weight: 700;
		color: #0a1633;
		margin: 48px 0 30px;
		text-align: center;
	}

	.AIProduct {
		display: flex;
		justify-content: space-between;

		li {
			width: 590px;
			background: #FFFFFF;
			box-shadow: 2px 2px 13px 0px rgba(156, 5, 5, 0.1);
			border: 2px solid #FFFFFF;
		}

		.system {
			height: 170px;
			position: relative;
			padding-left: 30px;
			padding-top: 32px;

			>img {
				width: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}

			>img+div {
				position: relative;
				z-index: 2;

				p:first-child {
					font-size: 20px;
					font-weight: bold;
					color: #282828;
					margin-bottom: 15px;
				}

				p:nth-of-type(2) {
					font-size: 14px;
					color: #282828;
				}

				button {
					width: 130px;
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 14px;
					margin-top: 26px;
				}

			}

		}

		.productItem {
			width: 552px;
			display: flex;
			flex-wrap: wrap;
			border: 1px solid #E4E4E4;
			margin: 20px auto;

			>div:nth-child(odd) {
				border-right: 1px solid #E4E4E4;
			}

			>div:nth-child(-n+2) {
				border-bottom: 1px solid #E4E4E4;
			}

			>div {
				width: 50%;
				height: 101px;
				cursor: pointer;
				padding: 23px 19px;

				p:first-child {
					font-size: 18px;
					font-weight: bold;
					color: #282828;
					margin-bottom: 12px;
				}

				p:last-child {
					font-size: 14px;
					color: #282828;
					letter-spacing: -1px;
				}
			}

			>div:hover {
				background: #F3F3F3;

				p:first-child {
					color: var(--mainColor);
				}

			}

		}

	}

	.services {
		width: 100%;
		height: 480px;
		background: url(../../assets/img/home/professionalServices.png) center center no-repeat;
		background-size: 100% 100%;
		display: flex;

		.category {
			width: 220px;
			border-right: 1px solid #BCBCBC;

			p {
				height: 160px;
				line-height: 160px;
				font-size: 20px;
				font-weight: bold;
				color: #282828;
				text-align: center;
				cursor: pointer;
			}

			.active {
				background: #F3F3F3;
				border-left: 2px solid var(--mainColor);
			}

		}

		.category+div {
			padding-left: 40px;

			>p {
				font-size: 24px;
				font-weight: bold;
				color: #282828;
				margin-top: 70px;
				margin-bottom: 40px;
			}

			>ul {
				li {
					height: 40px;
					line-height: 40px;
					position: relative;
					margin-bottom: 30px;
					display: flex;

					span:first-child {
						width: 200px;
						font-size: 14px;
						color: #fff;
						background: var(--mainColor);
						border-radius: 8px 0 0 8px;
						border: 1px solid var(--mainColor);
						padding: 0 14px;
					}

					span:last-child {
						width: 450px;
						font-size: 14px;
						color: #282828;
						border: 1px solid var(--mainColor);
						padding: 0 26px 0 20px;
						background: #fff;
						border-radius: 8px;
						position: relative;
						left: -38px;
						display: flex;
						justify-content: space-between;

						.seeDetails {
							color: var(--mainColor);
							cursor: pointer;
						}
						
						.seeDetails:hover{
							color: var(--complementaryColors);
							text-decoration: underline;
						}
						
					}

				}

			}

		}

	}

	.news {
		display: flex;

		li:not(:last-child) {
			margin-right: 20px;
		}

		li {
			width: 285px;
			height: 300px;
			position: relative;
			cursor: pointer;

			>img {
				width: 100%;
				height: 160px;
				// object-fit: contain;
				object-fit: cover;
				border-radius: 18px;
			}

			>div:hover p:first-child {
				color: var(--mainColor);
			}

			>div {
				width: 100%;
				height: 160px;
				background: #fff;
				box-shadow: 2px 2px 13px 0px rgba(156, 5, 5, 0.1);
				padding: 20px;
				border-radius: 10px;
				position: absolute;
				bottom: 0;

				p:first-child {
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					font-size: 16px;
					color: #282828;
					margin-bottom: 14px;
				}

				p:last-child {
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					font-size: 14px;
					color: #282828;
				}

			}

		}

	}

	.moreNews {
		width: 200px;
		height: 50px;
		line-height: 50px;
		text-align: center;
		border-radius: 10px;
		font-size: 18px;
		margin: 50px auto 0;
		display: block;
	}
</style>